<!-- =========================================================================================
  File Name: DataListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
    <data-view-camera-sidebar :isSidebarActive="addNewCameraSidebar" @getdata="getdata" @closeSidebar="toggleCameraSidebar" :data="cameraSidebarData" />
    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @getdata="getdata" @closeSidebar="toggleDataSidebar"  :data="sidebarData" />
    <data-view-camusersidebar :isCamUserSidebarActive="addNewCamUserSidebar" @getdata="getdata" @closeCamUserSidebar="toggleCamUserSidebar" :data="camUserSidebarData" />
    <student-setting-sidebar :isSettingSidebarActive="addSettingSidebar" @getdata="getdata" @closeSidebar="toggleSettingSidebar" :data="sidebarSettingData" />
    <schedule-view-sidebar :isSidebarActive="addScheduleSidebar" @getdata="getdata" @closeSidebar="toggleScheduleSidebar" :data="scheduleData" />
    <video-view  :setting="cameraSetting" :camera="cameraCode" :active="activeVideo"  @closeVideView="closeVideView"/>
<!-- ADD NEW -->
 <vs-popup fullscreen title="" :active.sync="popupActive">
    <div id="page-camera-view" >
    <iframe  width="100%" height="490" class="center" :src="reset"  allowfullscreen></iframe>
  </div>
      </vs-popup>
    <div>

    <vs-button class="user_add_btn" type="filled" @click.native="addNewData"><feather-icon icon="PlusIcon" class="flex-inline" svgClasses="h-3 w-3" /> {{ $t('student.add.title') }}</vs-button>
  <!-- <vs-button class="user_add_btn" radius icon="icon-plus" icon-pack="feather"    @click="addNewData"/> -->
  </div>

   <vs-table ref="table"  :data="filteredStudentList" :max-items="itemsPerPage"  pagination search>
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <!-- ACTION - DROPDOWN -->
          <vs-dropdown v-if="select>0" vs-trigger-click class="dd-actions cursor-pointer ml-4 mr-4 mb-4">

            <div class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2">{{ $t('common.action') }} ({{selected.length}})</span>
       </div>
            <vs-dropdown-menu>
              <vs-dropdown-item  @click="selectAction('deletestudent')">
                <span class="flex items-center">
                <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>{{ $t('common.delete') }}</span>
                </span>
              </vs-dropdown-item>
               <vs-dropdown-item  @click="selectAction('activestudent')">
                <span class="flex items-center" >
                  <feather-icon icon="ToggleRightIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>{{ $t('common.enable') }}</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="selectAction('deactivestudent')">
                <span class="flex items-center" >
                  <feather-icon icon="ToggleLeftIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>{{ $t('common.disable') }} </span>
                </span>
              </vs-dropdown-item>
               <vs-dropdown-item  @click="genQr()" >
                <span class="flex items-center">
                  <feather-icon icon="CodepenIcon" svgClasses="h-4 w-4" class="mr-2"  />
                  <span>{{ $t('common.qr_code') }}</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item  @click="SMSpopup()" >
                <span class="flex items-center">
                  <feather-icon icon="MessageSquareIcon" svgClasses="h-4 w-4" class="mr-2"  />
                  <span>Add {{ $t('menu.users.name') }}</span>
                </span>
              </vs-dropdown-item>
               <vs-dropdown-item  @click="getSudentForCamera()" >
                <span class="flex items-center">
                  <!-- <feather-icon icon="MessageSquareIcon" svgClasses="h-4 w-4" class="mr-2"  /> -->
                  <i class="material-icons mr-2 mb-1" style="font-size: 14px !important" svgClasses="h-4 w-4">add_a_photo</i>
                  <span>Assign Cameras</span>
                </span>
              </vs-dropdown-item>
              </vs-dropdown-menu>
          </vs-dropdown>
          <vx-tooltip text="Filter By" position="top">
          <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">

           <div class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2">{{FilterBy}}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
                <vs-dropdown-menu>
                <vs-dropdown-item @click="setFilter('All')">
                <span class="flex items-center" >
                  <span>ALL</span>
                </span>
              </vs-dropdown-item>    

              <vs-dropdown-item @click="setFilter('Locations')">
                <span class="flex items-center" >
                  <span>Locations</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item @click="setFilter('Programs')">
                <span class="flex items-center" >
                  <span>Programs</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item @click="setFilter('Status')">
                <span class="flex items-center" >
                  <span>Status</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item  @click="setFilter('Cameras')">
                <span class="flex items-center">
                  <span>Cameras</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>

          </vs-dropdown>
          </vx-tooltip> 
         
          <vx-tooltip text="Filter By" position="top" v-if="listFilter">
          <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">

           <div class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2" >{{SearchBy}}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu style="z-index:90000">
               <vs-dropdown-item v-for="item in listFilter" :key="item.id" @click="SearchItem(item)">{{ item.name }}
                <!-- <span class="flex items-center" @click="SearchItem(item)">
                  <span >{{ item.name }}</span>
                </span> -->
              </vs-dropdown-item>

            </vs-dropdown-menu>

          </vs-dropdown>
          </vx-tooltip> 
           <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mb-5" >
                  <div >
                    <feather-icon svgClasses="w-8 h-8 hover:text-primary stroke-current"  icon="FilterIcon" @click.stop=""></feather-icon>
                  </div>
                  <vs-dropdown-menu class="mb-5">
                  <vs-dropdown-item>
                  <span class="flex items-center"  @click="getArchive()">
                 <feather-icon icon="ArchiveIcon" svgClasses="h-6 w-6" class="mr-2 "/>  <span> Archived </span>
                </span>
                  </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ students.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : students.length }} of {{ queriedStudents }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>

            <vs-dropdown-item @click="setitemsPerPage(25)">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="setitemsPerPage(50)">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item  @click="setitemsPerPage(75)">
              <span>75</span>
            </vs-dropdown-item>
             <vs-dropdown-item @click="setitemsPerPage(100)">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead" >
        <vs-checkbox v-model="headCheckbox" @input="CheckAll()"></vs-checkbox>
        <vs-th>
        <span  @click="sorting('name')">{{ $t('student.table.name') }}</span>
        <feather-icon v-if="order && namestate" icon="ChevronDownIcon" svgClasses="h-4 w-4" class="ml-1" @click="sorting('name')" />
        <feather-icon v-if="!order && namestate" icon="ChevronUpIcon" svgClasses="h-4 w-4"  class="ml-1" @click="sorting('name')" />
        </vs-th>
        <vs-th>{{ $t('student.table.users') }}</vs-th>
        <vs-th>
        <span   @click="sortingprogram('program')">{{ $t('student.table.program') }}</span>
        <feather-icon v-if="programorder && programstate" icon="ChevronDownIcon" svgClasses="h-4 w-4" class="ml-1" @click="sortingprogram('program')" />
        <feather-icon v-if="!programorder && programstate" icon="ChevronUpIcon" svgClasses="h-4 w-4" class="ml-1" @click="sortingprogram('program')" />
        </vs-th>

        <vs-th>
        <span  @click="sortingstatus('status')">{{ $t('student.table.status') }}</span>
        <feather-icon v-if="statusorder && state" icon="ChevronDownIcon" svgClasses="h-4 w-4" class="ml-1" @click="sortingstatus('status')" />
        <feather-icon v-if="!statusorder && state" icon="ChevronUpIcon" svgClasses="h-4 w-4" class="ml-1" @click="sortingstatus('status')" />
        </vs-th>
        <vs-th>{{ $t('student.table.cameras') }}</vs-th>
        <vs-th>{{ $t('student.table.action') }}</vs-th>
      </template>

        <template slot-scope="{data}" >
          <tbody >
            <vs-tr  :data="tr" :key="indextr" v-for="(tr, indextr) in data" v-bind:class="{ 'bg-light_danger': !tr.location.billing, 'text-dark': !tr.location.billing }" >
            <vs-td><vs-checkbox  @input="SelectItem(tr.id)" v-model="selectedCheck[indextr]" :disabled="!tr.location.billing" ></vs-checkbox></vs-td>
            <vs-td>
            <span @click="goto(tr.id)">
           <!-- <router-link :to="{ path: '/'+ $t('route.student_profile.title') +'/'+ tr.id}" class="text-inherit " > -->
           <img v-if="tr.image" :src="img_cdn+tr.image" class="rounded-full coverimg shadow-md studentdot mr-2" style="object-fit:cover" loading="lazy"/>
           <p v-else class="bg-primary studentdot text-white mr-2" :data-letterstudent="tr.fname[0].toUpperCase()"></p>
          <!-- <img  :src="`/storage/images/${tr.image}`" class="rounded-full shadow-md product-img" /> -->
              <!-- <img :src="tr.image"   class="rounded-full shadow-md product-img" /> -->
                <span v-if="lng=='dogs'" class="text-sm font-bold">{{tr.fname}}</span>
                <span v-else class="text-sm font-bold">{{tr.fname}} {{tr.middle_name}} {{tr.lname}}</span>
           <!-- </router-link> -->
            </span>
            </vs-td>

                <vs-td>
                <div v-for="item in tr.users" :key="item.id">
                   <router-link :to="{ path: '/'+ $t('route.user_profile.title') +'/'+ item.id}" class="text-inherit underline">
                 <vs-chip >{{item.fname}} {{item.lname}}</vs-chip>
                  </router-link>
                </div>
                <!-- <feather-icon class="text-primary text-center" style = "text-align:center;"  @click.stop="addNewCamUser(tr)" icon="UserPlusIcon" svgClasses="h-4 w-4"/>  -->


              <vs-row>
              <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="12">
              <vs-button  class="text-center" :disabled="!tr.location.billing"  @click.native="addNewCamUser(tr)" size="small" icon-pack="feather" icon="icon-user-plus"></vs-button>

              <!-- <vs-button size="small" class="text-center" style="width:10px;float:left"  @click.stop="addNewCamUser(tr)"> -->
                 <!-- <feather-icon class="text-primary text-center" style = "text-align:center;"  @click.stop="addNewCamUser(tr)" icon="UserPlusIcon" svgClasses="h-4 w-4"/>  -->
                 <!-- <vs-button  class="text-center" style = "text-align:center;"  @click.stop="addNewCamUser(tr)" size="small" icon-pack="feather" icon="icon-user-plus"></vs-button>  -->
                <!-- {{ $t('student.table.add_user') }} -->
                <!-- </vs-button> -->
                <!-- <vs-button radius color="danger" type="gradient" icon-pack="feather" icon="icon-user-plus"></vs-button> -->
              </vs-col>
               </vs-row>
              </vs-td>
              <!-- <vs-td>
                <router-link :to="{ path: '/'+ $t('route.student_profile.title') +'/'+ tr.id}" class="text-inherit " >
                <p v-if="lng=='dogs'" class="text-sm font-small">{{tr.fname}}</p>
                <p v-else class="text-sm font-small">{{tr.fname}} {{tr.middle_name}} {{tr.lname}}</p>
                </router-link>
              </vs-td> -->
              <vs-td>
                <vs-chip v-if="tr.program.color_code" class="product-order-status text-white" :style="{background: tr.program.color_code}">{{ tr.program.name | title }}</vs-chip>
                <vs-chip v-else class="product-order-status" >{{ tr.program.name | title }}</vs-chip>
              </vs-td>
              <vs-td>
                <vs-switch @input="confStatus(tr.status,tr.id)" :disabled="!tr.location.billing" v-model="tr.status"></vs-switch>
              </vs-td>
              <vs-td>
              <vx-tooltip class="vs-display" v-for="item in tr.cameras" :key="item.id" :text="item.name" position="top">
               <span   @click="PlayCamera(item.id,item.code,item.location_setting.location_camera_setting,item.location_setting.id)"  :style="{background: item.color_code}" class="w-4 h-4 round" style="float: left"></span>
                </vx-tooltip>
                  <br v-if="tr.cameras.length>0">
                 <!-- <vs-button class="w-2 h-2 round"  @click="addCameraData(tr)"  icon="add">
                  </vs-button> -->
                <vs-row >
              <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="12">
             <vs-button icon="add_a_photo" @click.native="addNewCamera(tr)" size="small"></vs-button>
              </vs-col>
               </vs-row>
              </vs-td>
              <vs-td class="whitespace-no-wrap" >
                 <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer" v-if="tr.location.billing" >
                  <div >
                    <feather-icon svgClasses="w-6 h-6 hover:text-primary stroke-current" class="ml-2" icon="MoreVerticalIcon" @click.stop=""></feather-icon>
                  </div>
                  <vs-dropdown-menu>
                  <vs-dropdown-item>
                  <span class="flex items-center">
                  <router-link :to="{ path: '/'+ $t('route.student_profile.title') +'/' + tr.id}" class="text-inherit " >
                 <feather-icon icon="EyeIcon" svgClasses="h-4 w-4" class="mr-2 "/>  <span> View </span>
                  <!-- <span> {{ $t('common.edit') }} </span> -->

                </router-link>
                </span>
                  </vs-dropdown-item>
                  <vs-dropdown-item @click="editData(tr)">
                <span class="flex items-center" >
                  <feather-icon icon="EditIcon" svgClasses="h-4 w-4" class="mr-2"/>
                  <span> {{ $t('common.edit') }} </span>
                </span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="confirmDeleteRecord(tr)">
                <span class="flex items-center" >
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2 "/>
                  <span>{{ $t('common.delete') }}</span>
                </span>
                </vs-dropdown-item>
                    <vs-dropdown-item @click="settingData(tr)">
                <span class="flex items-center" >
                  <feather-icon icon="SettingsIcon"  svgClasses="h-4 w-4" class="mr-2"/>
                  <span>{{ $t('student.action.settting') }}s</span>
                </span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="addSchedule(tr)">
                <span class="flex items-center" >
                  <feather-icon icon="CalendarIcon"  svgClasses="h-4 w-4" class="mr-2"/>
                  <span>{{ $t('student.action.schedule') }}</span>
                </span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="MessagePopupAction(tr.id)">
                <span class="flex items-center" >
                  <feather-icon icon="MessageCircleIcon"  svgClasses="h-4 w-4" class="mr-2"/>
                  <span>Messages</span>
                </span>
                </vs-dropdown-item>
                </vs-dropdown-menu>
                </vs-dropdown>
                 <vs-tooltip v-else text="This record is disabled because of its locations’ billing problems">
                   <feather-icon icon="InfoIcon" svgClasses="w-6 h-6" class="ml-2"  />
                 </vs-tooltip>
                </vs-td>
            </vs-tr>
          </tbody>
        </template>
    </vs-table>
     <div class="demo-alignment">
      <div class="fill-row-loading">
        <div :class="{'activeLoading':activeLoading}"  :id="[`loading-sound`]" class="vs-con-loading__container loading-example">
        </div>
      </div>
  </div>
  <vs-popup class="holamundo" title="QR Code" :active.sync="QRpopupActive">
             <vs-row>
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                  <vue-qrcode :value="Qr_link" :width="400" ref="QR" />
              </vs-col>
               </vs-row>
              <vs-row >
              <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
              <vs-button  @click.native="downloadQR()">Download</vs-button>
              <!-- <vs-button class="ml-10">Print</vs-button> -->

              </vs-col>
               </vs-row>
    <!-- <div > -->
    <!-- <img :src="QRcodeImg" width="60%" hight="50%" download /><br> -->
    <!-- <div > -->
       <!-- <vs-button  @click="QRpopupActive=false">{{ $t('common.save') }}</vs-button> -->

    <!-- </div>
    </div> -->
  </vs-popup>
  <div class="demo-alignment">
      <vs-popup fullscreen title="" :active.sync="ArchivePopup">
        <data-list-archive :isarchiveActive="archiveSidebar" @getdata="getdata" @popActive="popActive" :reset="archiveReset"/>
            <vs-popup title="Permanent Delete" :active.sync="popupActive3" >
        <div class="flex">
        <p>Do you want to permanently delete?</p> <vs-button @click.native="permanentDelete()" class="ml-2" size="small" color="danger">Yes</vs-button><vs-button @click.native="popupActive3=false" class="ml-5" size="small" color="primary">No</vs-button>
        </div>
      </vs-popup>
      </vs-popup>
  </div>
  <vs-popup title="SEND SMS INVITATION FOR" fullscreen  :active.sync="SMSpopupActive">
    <form-wizard color="rgba(var(--vs-primary), 1)" :title="null" :subtitle="null" finishButtonText="Submit" nextButtonText="Next" @on-complete="SendSmsToUser" ref="wizard">
      <tab-content title="Step 1" class="mb-5" :before-change="CheckSms" >
      <h3 class="text-primary mb-5 px-4">Add {{ $t('menu.users.name') }}</h3>
      <h6 class="ml-5 mb-5">{{ $t('menu.users.name') }} can manage their {{ $t('student.titlesmall') }}s, view or edit different settings of the {{ $t('student.titlesmall') }}s and watch cameras.
      </h6>

          <!-- tab 1 content -->
    <vs-row v-for="(smsstudent, index) in SmsStudent" :key="index" class="p-1">
    <vs-col vs-type="flex" vs-justify="center" vs-align="center"  vs-w="2">
       <vs-chip v-if="smsstudent.image">
       <vs-avatar :src="img_cdn+smsstudent.image"/>
       {{smsstudent.fname}} {{smsstudent.middle_name}} {{smsstudent.lname}} <br>
        {{smsstudent.program.name}}
      </vs-chip>
       <vs-chip v-else>
       <vs-avatar/>
       {{smsstudent.fname}} {{smsstudent.middle_name}} {{smsstudent.lname}}
        <br>
        {{smsstudent.program.name}}
      </vs-chip>
  </vs-col>
    <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
     <vs-row >
       <div v-for="(user, indexx) in smsstudent.Users" :key="indexx" class="w-full">
        <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
           <vs-input class="w-full" label-placeholder="First Name" v-model="user.fname" />
      </vs-col>
              <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
           <vs-input class="w-full" label-placeholder="Last Name" v-model="user.lname" />
      </vs-col>
              <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
           <vs-input  class="w-full"  type="email" label-placeholder="Email" v-model="user.email" @input="acceptEmail(user.email,index,indexx)" :name="'email '+String(indexx+1)" v-validate="'email'"/>
                <span class="text-danger text-sm mt-20" style="position: absolute" v-show="errors.has('email '+String(indexx+1))">{{ errors.first('email '+String(indexx+1)) }}</span>

              </vs-col>
          <vs-col  vs-type="flex" vs-w="3">
           <span>
           <vs-input @input="acceptNumber(user.phone,index,indexx)" class="w-full" label-placeholder="Phone Number" v-model="user.phone" />
            <span  class="text-danger text-sm" v-if="user.phone.length > 0 &&  user.phone.length < 14"  >Invalid phone number format.</span>
           </span>
           <span class="danger mt-3 ml-1" @click="removeNumber(index,indexx)"  style="color:red ;cursor: pointer">x</span>
           </vs-col>
      </div>
        <vs-col vs-offset="10" vs-type="flex" vs-justify="flex-end" vs-align="flex-end" vs-w="2">
              <vs-button color="primary" size="small" @click.native="addNewNumber(index)" class="mt-1">
         <feather-icon icon="PlusIcon" svgClasses="h-2 w-2"/>
         </vs-button>
    </vs-col>

    </vs-row>
  </vs-col>
   <vs-divider />
</vs-row>
      </tab-content>

      <!-- tab 2 content -->
      <tab-content title="Step 2" class="mb-5 ">
    <h3 class="text-primary mb-5 px-4">Notification Settings</h3>
          <h6 class="ml-5 mb-5"> What kind of invitation notifications, do you want to send?</h6>

    <vs-row v-for="(smsstudent, index) in SmsStudent" :key="index" class="p-1">
    <vs-col vs-type="flex" vs-justify="center" vs-align="center"  vs-w="2">
       <vs-chip v-if="smsstudent.image">
       <vs-avatar :src="img_cdn+smsstudent.image"/>
       {{smsstudent.fname}} {{smsstudent.lname}} <br>
        {{smsstudent.program.name}}
      </vs-chip>
       <vs-chip v-else>
       <vs-avatar/>
       {{smsstudent.fname}}  {{smsstudent.lname}}
        <br>
        {{smsstudent.program.name}}
      </vs-chip>
  </vs-col>
    <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
     <vs-row >
          <div v-for="(user, indexx) in smsstudent.Users" :key="indexx" class="vx-col w-full lg:w-1/5 sm:w-1/4 mb-2 ml-2">
                <vx-card>
                  <div class="text-center">
                        <h6>{{user.fname}} {{user.lname}}</h6>
                         <small>{{user.email}}</small><br v-if="user.email">
                         <small>{{user.phone}}</small>
                    </div>
                <div>
                  <span class="inline-flex text-center">
                    <vs-checkbox v-model="user.sms_notif" v-if="user.phone"></vs-checkbox>
                     <vs-checkbox v-else v-model="user.sms_notif" disabled="true"></vs-checkbox>
                    <small class="mt-1">Send invite sms</small>
                    </span>
                     <span class="inline-flex text-center">
                     <vs-checkbox v-model="user.email_notif" v-if="user.email"></vs-checkbox>
                     <vs-checkbox v-else v-model="user.email_notif" disabled="true"></vs-checkbox>
                    <small class="mt-1">Send invite email</small>
                    </span>
                </div>
                </vx-card>
            </div>
       <!-- <div v-for="(user, indexx) in smsstudent.Users" :key="indexx" class="w-full p-1">
        <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
         <p>{{user.fname}} {{user.lname}}</p>
       </vs-col>
          <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
          <p>{{user.phone}}</p>
          </vs-col>
          <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
            <vs-switch v-model="user.email_notif" v-if="user.email"/>
            <vs-switch v-else v-model="user.email_notif" disabled="true"/>
            Email
          </vs-col>
          <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
          <vs-switch v-model="user.sms_notif" v-if="user.email"/>
          <vs-switch v-else v-model="user.sms_notif" disabled="true"/>
          SMS
          </vs-col>
      </div> -->
    </vs-row>
  </vs-col>
   <vs-divider />
</vs-row>
<!-- <vs-row vs-type="flex" vs-justify="center" >
  <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
              <p>{{CounterMsg}}</p> -->

    <!-- <vx-card
    class="text-center"
    title-color="#fff"
    card-background="primary"
    content-color="#fff">


          {{getCount()}}
</vx-card>  -->
  <!-- </vs-col>
</vs-row> -->
      </tab-content>

      <!-- tab 3 content -->
      <!-- <tab-content title="Step 3" class="mb-5">
          <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full">
                  <vs-input label="Event Name" v-model="eventName" class="w-full mt-5" />
              </div>
              <div class="vx-col md:w-1/2 w-full">
                  <vs-select v-model="city" class="w-full select-large mt-5" label="Event Location">
                      <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in cityOptions" class="w-full" />
                  </vs-select>
              </div>
              <div class="vx-col md:w-1/2 w-full mt-5">
                  <vs-select v-model="status" class="w-full select-large" label="Event Status">
                      <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in statusOptions" class="w-full" />
                  </vs-select>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mt-8">
                  <div class="demo-alignment">
                      <span>Requirements:</span>
                      <div class="flex">
                        <vs-checkbox>Staffing</vs-checkbox>
                        <vs-checkbox>Catering</vs-checkbox>
                      </div>
                  </div>
              </div>
          </div>
      </tab-content> -->
  </form-wizard>

  <!-- <vs-row v-for="(smsstudent, index) in SmsStudent" :key="index" class="p-1"> -->
  <!-- <vs-col vs-type="flex" vs-justify="center" vs-align="center"  vs-w="2">
       <vs-chip v-if="smsstudent.image">
       <vs-avatar :src="img_cdn+smsstudent.image"/>
       {{smsstudent.fname}} {{smsstudent.lname}} <br>
        {{smsstudent.program.name}}
      </vs-chip>
       <vs-chip v-else>
       <vs-avatar/>
       {{student.fname}}  {{smsstudent.lname}}
        <br>
        {{smsstudent.program.name}}
      </vs-chip>
  </vs-col>
    <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="10">
     <vs-row >
       <div v-for="(user, indexx) in smsstudent.Users" :key="indexx" class="w-full">
        <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
           <vs-input class="w-full" label-placeholder="First Name" v-model="user.fname" />
      </vs-col>
              <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
           <vs-input class="w-full" label-placeholder="Last Name" v-model="user.lname" />
      </vs-col>
              <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
           <vs-input  class="w-full"  type="email" label-placeholder="Email" v-model="user.email" @input="acceptEmail(user.email,index,indexx)" name="email" v-validate="'email|required'"/>
      </vs-col>
            <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="3">
           <vs-input @input="acceptNumber(user.phone,index,indexx)" class="w-full" label-placeholder="Phone Number" v-model="user.phone" />
           <span class="danger mt-3 ml-1" @click="removeNumber(index,indexx)"  style="color:red ;cursor: pointer">x</span>
           </vs-col>
            <vs-col vs-offset="6"  vs-type="flex" vs-justify="center" vs-align="center" vs-w="3" v-if="user.check > 0" class="text-danger text-sm" >Email Already Taken!
            </vs-col>
             <vs-col v-if="user.phone.length > 0 &&  user.phone.length < 14"  vs-type="flex" vs-justify="center" vs-align="center" vs-w="3" class="text-danger text-sm"> Invalid phone number format.
            </vs-col>
      </div>
        <vs-col vs-offset="10" vs-type="flex" vs-justify="flex-end" vs-align="flex-end" vs-w="2">
              <vs-button color="primary" size="small" @click="addNewNumber(index)" class="mt-1">
         <feather-icon icon="PlusIcon" svgClasses="h-2 w-2"/>
         </vs-button>
    </vs-col>

    </vs-row>
  </vs-col>
   <vs-divider />
</vs-row> -->
<!-- <vs-row >
<vs-col vs-type="flex" vs-justify="flex-end" vs-align="flex-end" vs-w="12">
<vs-button @click="sendSms" color="success">Send</vs-button>
</vs-col>
</vs-row> -->
    <!-- <div class="vx-row" v-for="(student, index) in SmsStudent" :key="index">
    <div class="vx-col sm:w-1/5 w-full mb-2">
      <vs-input class="w-full" label-placeholder="Student Name" v-model="student.name" />
    </div>
    <div class="vx-col sm:w-1/4 w-full mb-2">
      <vs-input class="w-full" label-placeholder="First Name" v-model="input25" />
      <vs-input class="w-full" label-placeholder="Last Name" v-model="input26" />
      <vs-input class="w-full" label-placeholder="Email" v-model="input27" />
      <vs-input class="w-full" label-placeholder="Email" v-model="input27" />
    </div>
  </div> -->


  <!-- <label class="vs-select--label w-full pl-12">Selectd Students</label>
  <vs-row class="pl-10">
  <vs-col  vs-type="flex" vs-justify="left" vs-align="left" vs-w="8"  >
      <ul id="menu">
       <li  v-for="(student, index) in sms_student" :key="index">
       <vs-chip>
       <vs-avatar :src="img_cdn+student.image"/>
       {{student.fname}} {{student.lname}}
      </vs-chip>
       </li>
     </ul>
  </vs-col>
 </vs-row>
  <vs-row class="pt-5">
  <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="8"  >
     <ul>
       <li></li>
       <li v-for="(PhoneNumber, index) in SmsNumber" :key="index">
         <span class="flex">
        <vs-input class="pl-10" placeholder="Enter Phone" v-model="PhoneNumber.phone" @input="acceptNumber(PhoneNumber.phone,index)" style="width:350px" />
             <span  class="text-danger mt-2 ml-2 font-bold" style="cursor: pointer"  @click="removeNumber(index)">x</span>

         </span>
          <span  v-if="PhoneNumber.phone.length > 0 &&  PhoneNumber.phone.length < 14" class="text-danger text-sm pl-10">Invalid phone number format.</span><br>
       </li>
       <li>
         <vs-button color="primary" size="small" @click="addNewNumber()" style="float:right" class="mr-6">
         <feather-icon icon="PlusIcon" svgClasses="h-2 w-2"/>

         </vs-button></li>
     </ul>
  </vs-col> -->
   <!-- <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-w="4" class="pt-0">
     <ul>
       <li  v-for="(student, index) in sms_student" :key="index">
      <vs-chip >
      <vs-avatar :src="img_cdn+student.image"/>
      {{student.fname}} {{student.lname}}
      </vs-chip>
       </li>
     </ul>
  </vs-col> -->
 <!-- </vs-row> -->
 <!-- <vs-divider /> -->
              <!-- <vs-button style="float:right" color="primary" @click="sendSms()" :disabled="SendSMSbtn" >Send</vs-button> -->


               <!-- <span  class="material-icons text-primary"  @click="addNewNumber()">add</span> -->


             <!-- <vs-row>
              <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="12" class="w-full">
               <label for="">Phone: </label>    <vs-input></vs-input>
              </vs-col>
               </vs-row>
              <vs-row >
              <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="12">
              <vs-button  color="success">Send</vs-button>
              </vs-col>
               </vs-row> -->
  </vs-popup>
        <vs-popup title=" "  :active.sync="MessagePopup" >
        <div class="flex">
          <data-message-view  :ismessageActive="messageSidebar" :data="messageData"/>
        </div>
      </vs-popup>
  <vs-popup fullscreen title="Assign Cameras" :active.sync="addCameraPopup">
    <vs-row>
     <vs-col  vs-justify="center" vs-align="center" vs-w="12">
       <span  v-for="(item, index) in addNewCameraPopUpData" :key="index" >
       <h3>{{getLocationName(index)}}</h3>
       <vs-row class="mb-5 mt-2">
       <vs-col  vs-justify="center" vs-align="center" vs-w="12" ><vs-chip v-for="student in item" :key="student.id" class=" inline-flex">
         <vs-avatar v-if="student.image" class="coverimg" :src="img_cdn + student.image" />
            <vs-avatar v-else />
        {{student.fname}} {{student.lname}}
        </vs-chip>
      </vs-col>
      </vs-row>
       <vs-row>
      <vs-col  vs-justify="center" vs-align="center" vs-w="12" >
       <label class="vs-select--label w-full">Select Cameras</label>
         <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer ml-4 " v-if="newGroups[index] && newGroups[index].length>0">
        <a class="flex items-center" style="font-size: .85rem;">
           Copy from group 
          <i class="material-icons">expand_more</i>
        </a>
        <vs-dropdown-menu style="z-index:9999999;">
          <vs-dropdown-item v-for="group in newGroups[index]" :key=group.id @click="getGroupCamera(group,index)">
            {{group.name}}
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>  
      <v-select style="width: 300px !important;" class="mb-base" label="name" value="id" multiple :closeOnSelect="true"  v-model="selectedCameras[index]"  :options="newCameras[index]"/>
      </vs-col>
      </vs-row>

   </span>
   <div class="vx-col w-full mb-base">
            <vs-checkbox 
              class="inline-flex"
              v-model="replaceCameras"
              >Replace all existing cameras</vs-checkbox>
          </div>
   <vs-button @click="addCamerasToUser"> Submit</vs-button>
  </vs-col>
</vs-row>


 
      </vs-popup>
  </div>
</template>

<script>

import VueQrcode from 'vue-qrcode'
import StudentSettingSidebar from './StudentSettingSidebar.vue'
import DataViewSidebar from './DataViewSidebar.vue'
import InviteCamUserSidebar from './InviteCamUserSidebar.vue'
import ScheduleViewSidebar from './ScheduleViewSidebar'
import DataListArchive from './DataListArchive'
import DataMessageView from './DataMessageView'
import DataViewCameraSidebar from './DataViewCameraSidebar.vue'
import {FormWizard, TabContent} from 'vue-form-wizard'
import {MailIcon, MessageSquareIcon, PhoneIcon} from 'vue-feather-icons'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import VideoView from '../../components/VideoView.vue'
import vSelect from 'vue-select'

import {
  ADD_INVITES,
  ALL_CAMERAS,
  ACTIVE_LOCATIONS,
  ALL_STUDENTS,
  CAMERAS_BY_MANAGER_LOCATION,
  FORCE_DELETE_ALL_STUDENT,
  GENERATE_QR,
  GENERATE_SMS_STUDENT,
  GET_CAMERA_BY_LOCATION,
  PLAY_CAMERA,
  REMOVE_STUDENT,
  SEND_SMS_TO_USER,
  SINGLE_USER,
  SINGLE_USER_BY_EMAIL,
  STUDENTS_BY_LOCATION,
  UPDATE_STUDENT_STATUS,
  CREATE_USER_ACTIVITY,
  CREATE_MULTIPLEUSER_ACTIVITY,
  USER_EMAIL_CONFIRMED,
  ALL_PROGRAMS_QUERY,
  ADD_CAMERAS_TO_STUDENT_ACTION,
  GET_GROUPS_BY_LOCATION,
  GET_GROUP_CAMERAS 
} from '@/graphql'

export default {
  components: {
    DataViewSidebar,
    'DataViewCamusersidebar': InviteCamUserSidebar,
    StudentSettingSidebar,
    ScheduleViewSidebar,
    DataListArchive,
    VueQrcode,
    FormWizard,
    TabContent,
    MailIcon,
    PhoneIcon,
    DataMessageView,
    'message-square-icon':MessageSquareIcon,
    'video-view':VideoView,
    DataViewCameraSidebar,
    'v-select': vSelect
  },

  data () {
    return {
      order:false,
      statusorder:true,
      state:false,
      namestate:false,
      programorder:true,
      programstate:false,
      QRpopupActive: false,
      IframeSrc:'',
      headCheckbox:'',
      selectedCheck:[],
      encrptId: '',
      students: [],
      selected: [],
      cameras: [],
      locations: [],
      itemsPerPage: 25,
      isMounted: false,
      meID: '',
      meRole: '',
      img_cdn:process.env.VUE_APP_AWS_s3Url+"/",
      lng:'',
      types: ['sound'],

      QRcodeImg:require('@/assets/images/portrait/small/qrcode.png'),
      popupActive: false,
      activeLoading:false,
      custom_search_filter:'Search By Location',
      custom_search_filter_camera:'Search By Camera',
      // products: [],

      // Data Sidebar
      addNewDataSidebar: false,
      archiveSidebar: false,
      addNewCamUserSidebar: false,
      addSettingSidebar: false,
      addPasswordSidebar:false,
      addScheduleSidebar:false,
      sidebarSettingData: {},
      sidebarData: {},
      camUserSidebarData : {},
      scheduleData:{},
      Imgdlt:'',
      DeletedItem:'',
      loc_id:'',
      qr_link:'google.com',
      action:'',
      ArchivePopup:false,
      popupActive3:false,
      SMSpopupActive:false,
      addCameraPopup:false,
      SmsNumber:[
        {
          phone :''
        }
      ],
      sms_link:'',
      sms_student:'',
      SendSMSbtn:false,
      SmsStudent:'',
      Duplicate:0,
      SuccessMsg:false,
      CounterMsg:'',
      MessagePopup : false,
      messageSidebar: false,
      messageData:{},
      FilterBy:'Filter By',
      SearchBy:'Search By',
      listFilter:null,
      search_item:null,
      statuses:[
        {
          id:'1',
          name:'Active',
          value:true
        },
        {
          id:'2',
          name:'Inactive',
          value:false
        }
      ],
      programs:[],
      cameraSetting:[],
      cameraCode:null,
      activeVideo:false,
      archiveReset:false,
      addNewCameraSidebar: false,
      cameraSidebarData : {},
      addCameraStudent:[],
      newCameras:[],
      selectedCameras:[],
      replaceCameras:false,
      newGroups:[]

    }
  },
  watch:{
     addCameraPopup(val){
       if(!val){
                 this.addCameraStudent=[]
                 this.selectedCameras=[]
                 this.newGroups=[]
       }
     }
  },
  computed: {
    filteredStudentList () {
      const filterby = this.FilterBy
      const search_item = this.search_item
      return this.students.filter(function (student) {
        if ((filterby === 'Filter By' && search_item === null)) {
          return true
        } else if (filterby === 'Filter By Cameras' && search_item !== null) {
          for (let i = 0; i < student.cameras.length; i++) {
            if (student.cameras[i].name === search_item) {
              return true
            } else {
              return false
            }
          }
        } else if (filterby === 'Filter By Locations' && search_item !== null) {
          return student.location.name.match(search_item)
        } else if (filterby === 'Filter By Status' && search_item !== null) {
          if (student.status === search_item) {
            return true
          } else {
            return false
          }
        } else if (filterby === 'Filter By Programs' && search_item !== null) {
          return student.program.name.match(search_item)
        } else {
          return true
        }
      })
      // const custom_search_filter_camera = this.custom_search_filter_camera
      // const custom_search_filter = this.custom_search_filter
      // return this.students.filter(function (student) {
      //   if (custom_search_filter_camera != 'Search By Camera' && custom_search_filter == 'Search By Location') {
      //     for (var i = 0; i < student.cameras.length; i++) {
      //       if (student.cameras[i].name == custom_search_filter_camera) {
      //         return true
      //       }
      //     }
      //     return false
      //   } else if (custom_search_filter_camera != 'Search By Camera' && custom_search_filter != 'Search By Location') {
      //     for (var i = 0; i < student.cameras.length; i++) {
      //       if (student.cameras[i].name == custom_search_filter_camera && student.location.name == custom_search_filter) {
      //         return true
      //       }
      //     }
      //     return false
      //   } else if (custom_search_filter_camera == 'Search By Camera' && custom_search_filter != 'Search By Location') {

      //     if (student.location.name == custom_search_filter) {
      //       return true
      //     } else {
      //       return false

      //     }
      //   } else if (custom_search_filter == 'Search By Location') {
      //     return true
      //   }
      //   // if(custom_search_filter !== 'Search By Location'){
      //   //   return student.location.name.match(custom_search_filter);
      //   // }
      //   return true
      // })
    },
    addNewCameraPopUpData(){
      return this.addCameraStudent

    },
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },

    locln () {
      return this.locations.length
    },
    queriedStudents () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.students.length
    },
    select () {
      return this.selected.length
    },
    reset () {
      if (this.popupActive) {
        return this.IframeSrc
      }
      if (!this.popupActive) {

      }
    },
    Qr_link () {
      return this.qr_link
    }
  },
  methods: {
    addCamerasToUser(){
      var allData = this.addCameraStudent
        this.$apollo
        .mutate({
          mutation: ADD_CAMERAS_TO_STUDENT_ACTION,
          variables: {
            data:JSON.stringify(allData),
            cameras:JSON.stringify(this.selectedCameras),
            isReplace:this.replaceCameras
           }
          })
            .then(response => {
              if(response.data.addCamerasToStudentAction.status==='Success'){
                  this.$vs.notify({
                    title: this.$t('menu.students.name'),
                    text: "Camera update successfully",
                    position: 'top-right',
                    color: 'success'
                  })
                  this.selected = []
              this.headCheckbox = false
              for (let index = 0; index < this.selectedCheck.length; index++) {
                this.selectedCheck[index] = false
              }
                 this.addCameraStudent=[]
                 this.addCameraPopup=false
                 this.selectedCameras=[]
                 this.newGroups=[]
                 this.get()
              }
            }).catch(error => {
            console.log(error)
          });     
    },
    goto(id){
      this.$router.push(this.$t('route.student_profile.title') +'/'+id)
    },
    SearchItem (item) {
      if (this.FilterBy === 'Filter By Status') {
        if (item.name === 'Active') {
          this.search_item = true
        } else {
          this.search_item = false
        }
      } else {
        this.search_item = item.name
      }
      this.SearchBy = item.name
      this.selected = []
              this.headCheckbox = false
              for (let index = 0; index < this.selectedCheck.length; index++) {
                this.selectedCheck[index] = false
              }
    },
    setFilter (item) {
      if (item === 'All') {
        this.FilterBy = 'Filter By'
        this.SearchBy =  null
        this.listFilter = null
      } else {
        this.FilterBy = `Filter By ${  item}`
        this.SearchBy = 'Search By'
        this.search_item = null
        // this.SearchBy="Search By "+item
        if (item === 'Locations') {
          this.listFilter = this.locations
        }
        if (item === 'Cameras') {
          this.listFilter = this.cameras
        }
        if (item === 'Status') {
          this.listFilter = this.statuses
        }
        if (item === 'Programs') {
          this.listFilter = this.programs
        }
      }
      this.selected = []
              this.headCheckbox = false
              for (let index = 0; index < this.selectedCheck.length; index++) {
                this.selectedCheck[index] = false
              }
    },
    setitemsPerPage (number) {
      this.itemsPerPage = number
      localStorage.setItem('itemsPerPage', number)
    },
    MessagePopupAction (id) {
      // this.MessagePopup=true
      // this.messageSidebar = !this.messageSidebar
      // this.messageData = data
      // this.$store.dispatch('setStudent', [data])
      // const arr = this.students
      // for (let i = 0; i < arr.length; i++) { if (arr[i].id === data.id) { arr.splice(i, 1); i-- } }
      // arr.unshift(data)
      this.$store.dispatch('setStudent', null)
      this.$store.dispatch('setStudent', id)
      this.$router.push('/alerts')
    },
    acceptEmail (email, index, indexx) {
      this.$apollo
        .mutate({
          mutation: SINGLE_USER_BY_EMAIL,
          variables: {
            email
          }
        })
        .then(response => {
          if (response.data.userByEmail.length > 0) {
            this.SmsStudent[index].Users[indexx].check = 1
          } else {
            this.SmsStudent[index].Users[indexx].check = 0
          }
        }).catch(error => {
          console.log(error)
          this.SmsStudent[index].Users[indexx].check = 0
        })
    },
    SMSpopup () {
      this.$refs['wizard'].reset()
      this.$apollo
        .mutate({
          mutation: GENERATE_SMS_STUDENT,
          variables: {
            student_id:this.selected
          }
        })
        .then(response => {
          if (response) {
            const studentList = response.data.generateSmsStudent.students

            for (let j = 0; j < studentList.length; j++) {
              delete  studentList[j].__typename 
              studentList[j]['Users'] = [
                {
                  'fname': '',
                  'lname': '',
                  'email': '',
                  'phone': '',
                  'check': 0,
                  'sms_notif':false,
                  'email_notif':false

                }
              ]
            }
            this.SmsStudent = studentList
            this.SMSpopupActive = true
            this.selected = []
            this.headCheckbox = false
            for (let index = 0; index < this.selectedCheck.length; index++) {
              this.selectedCheck[index] = false
            }
          }
        }).catch(error => {
          console.log(error)
        })
      // const path = '/register'
      // this.qr_link = process.env.VUE_APP_APP_LINK + path
      // this.$apollo
      //   .mutate({
      //     mutation: GENERATE_SMS_LINK,
      //     variables: {
      //       link:this.qr_link,
      //       student_id:this.selected,
      //      }
      //     })
      //       .then(response => {
      //         if (response) {
      //           this.sms_link=response.data.generateSms.link
      //            this.sms_student=response.data.generateSms.students
      //         this.SMSpopupActive=true
      //              this.selected=[];
      //           this.headCheckbox=false
      //            for (let index = 0; index < this.selectedCheck.length; index++) {
      //                this.selectedCheck[index]=false;
      //            }
      //                     }
      //       }).catch(error => {
      //       console.log(error)
      //     });
    },
    acceptNumber (phone, index, indexx) {
      const x = phone
        .replace(/\D/g, '')
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/)

      this.SmsStudent[index].Users[indexx].phone = !x[2]
        ? x[1]
        : `(${  x[1]  }) ${  x[2]  }${x[3] ? `-${  x[3]}` : ''}`
    },
    checkIfDuplicateExists (w) {
      return new Set(w).size !== w.length
    },
    CheckSms () {
      if (!this.errors.any()) {
        let flag = false
        let emailflag = true
        const Emails = []
        if (this.SmsStudent.length > 0) {
          for (let i = 0; i < this.SmsStudent.length; i++) {
            if (this.SmsStudent[i].Users.length > 0) {

              for (let j = 0; j < this.SmsStudent[i].Users.length; j++) {
                if (this.SmsStudent[i].Users[j].fname.length > 0 && this.SmsStudent[i].Users[j].lname.length > 0 && this.SmsStudent[i].Users[j].check == 0  && ((this.SmsStudent[i].Users[j].phone.length == 14 || this.SmsStudent[i].Users[j].phone.length == 0) && ((this.SmsStudent[i].Users[j].email.length > 0) || (this.SmsStudent[i].Users[j].phone.length == 14 )))) {
                  if (this.SmsStudent[i].Users[j].email.length > 0) {
                    Emails.push(this.SmsStudent[i].Users[j].email)

                  }
                  flag = true
                } else {

                  this.$vs.notify({
                    title: this.$t('menu.students.name'),
                    text: `Fields are requied at ${  this.$t('student.alert_title')  } ${i + 1} ${  this.$t('user.alert_title')  } ${j + 1} `,
                    position: 'top-right',
                    color: 'danger'
                  })
                  flag = false
                  return false
                }
              }
            }
            else{
              this.$vs.notify({
              title: 'Error',
              text: `Add at least one ${  this.$t('user.titlesmall')  }`,
              position: 'top-right',
              color: 'danger'
            })
            return false
            }
          }
          emailflag = this.checkIfDuplicateExists(Emails)
          if (flag === true && emailflag === false) {
            //  this.putIntoInvite();
            // this.SendSmsToUser();
            for (let i = 0; i < this.SmsStudent.length; i++) {
              for (let j = 0; j < this.SmsStudent[i].Users.length; j++) {
                if (this.SmsStudent[i].Users[j].email.length == 0) {
                  this.SmsStudent[i].Users[j].email_notif = false
                } else {
                  this.SmsStudent[i].Users[j].email_notif = true
                }
                if (this.SmsStudent[i].Users[j].phone.length == 0) {
                  this.SmsStudent[i].Users[j].sms_notif = false
                } else {
                  this.SmsStudent[i].Users[j].sms_notif = true
                }
              }
            }
            // this.CounterMsg=`${total_email} Email and ${total_phone} SMS notifications will be sent.`
            return true
          } else {
            this.$vs.notify({
              title: 'Error',
              text: 'Fields have duplicate emails',
              position: 'top-right',
              color: 'danger'
            })
            return false
          }
        }
      } else {
        this.$vs.notify({
          title:'Error',
          text: 'Fields have invalid email formate',
          position: 'top-right',
          color: 'danger'
        })
        return false
      }
    },
    putIntoInvite () {
      this.$apollo
        .mutate({
          mutation: ADD_INVITES,
          variables: {
            students:this.SmsStudent
          }
        })
        .then(response => {
          if (response) {
            if (response.data.addInvites.status === 'Success') {
              this.StatusSuccess(response.data.addInvites.message, response.data.addInvites.color)
              //  this.SmsStudent=[]
              //  this.SMSpopupActive=false
              this.selected = []
              this.headCheckbox = false
              for (let index = 0; index < this.selectedCheck.length; index++) {
                this.selectedCheck[index] = false
              }
              this.get()
            }
          }
        }).catch(error => {
          // this.SendSMSbtn=false
          console.log(error)
        })
    },
    SendSmsToUser () {
      this.loader()
      this.$apollo
        .mutate({
          mutation: SEND_SMS_TO_USER,
          variables: {
            students:this.SmsStudent
          }
        })
        .then(response => {
          if (response) {
            if (response.data.sendSmsToUser.status === 'Success') {
              this.StatusSuccess(response.data.sendSmsToUser.message.response.data.sendSmsToUser.color)
              this.$refs['wizard'].reset()
              this.SmsStudent = []
              this.SMSpopupActive = false
              this.selected = []
              this.headCheckbox = false
              for (let index = 0; index < this.selectedCheck.length; index++) {
                this.selectedCheck[index] = false
              }
              this.get()
            }
          }
        }).catch(error => {
          // this.SendSMSbtn=false
          // console.log(error)
          this.$vs.notify({
            title: 'Success',
            text: 'Sent Successfully!',
            color: 'success',
            position: 'top-right'
          })
          this.$refs['wizard'].reset()
          this.SmsStudent = []
          this.SMSpopupActive = false
          this.selected = []
          this.headCheckbox = false
          for (let index = 0; index < this.selectedCheck.length; index++) {
            this.selectedCheck[index] = false
          }
          this.get()
        })
      return true
    },
    addNewNumber (index) {
      this.SmsStudent[index].Users.push(
        {
          fname:'',
          lname:'',
          email:'',
          phone:'',
          check: 0,
          sms_notif:false,
          email_notif:false
        }
      )
    },
    removeNumber (sindex, uindex) {
      this.SmsStudent[sindex].Users.splice(uindex, 1)
    },
    popActive (id) {
      this.DeletedItem = id
      this.popupActive3 = true
    },
    permanentDelete () {
      this.$apollo
        .mutate({
          mutation: FORCE_DELETE_ALL_STUDENT,
          variables: {
            id: this.DeletedItem
          }
        }).then(response => {
          this.studentMultipleActivity(this.DeletedItem,"permanent deleted")
          this.popupActive3 = false
          this.ArchivePopup = false
          this.DeletedItem = ''
          if (response.data.forceDeleteAllStudent.status === 'Success') {
            this.StatusSuccess(response.data.forceDeleteAllStudent.message, response.data.forceDeleteAllStudent.color)
            this.archiveReset=false
            this.getArchive()
          }
          //  if(response.data.deleteAllStudent.status=='Success'){
          //  this.StatusSuccess(response.data.deleteAllStudent.message,response.data.deleteAllStudent.color)
          //  this.$emit('getdata',true)
          // }
        }).catch(error => {

        })
    //     this.$apollo
    //   .mutate({
    //     mutation: FORCE_DELETE_STUDENT,
    //     variables: {
    //     id: this.DeletedItem,
    //  },
    //   })
    //   .then(response => {
    //      this.popupActive3=false
    //      this.ArchivePopup=false
    //      if(response.data.forceDeleteStudent.status=='Success'){
    //         this.StatusSuccess(response.data.forceDeleteStudent.message,response.data.forceDeleteStudent.color)
    //         this.getArchive()
    //       }
    //     }).catch(error => {
    //      console.log(error)
    //   });
    },
    toggleCameraSidebar (val = false) {
      this.addNewCameraSidebar = val
    },
     addNewCamera (data) {
      this.cameraSidebarData = data
      this.toggleCameraSidebar(true)
    },
    
    getArchive () {
      this.ArchivePopup = true
      this.archiveSidebar = !this.archiveSidebar

    },
    downloadQR () {
      const img = this.$refs.QR.$el
      const a = document.createElement('a')
      a.href = img.src
      a.download = 'QR_CODE'
      a.click()
      this.QRpopupActive = false
    },
    genQr () {
      const path = '/register'
      this.qr_link = process.env.VUE_APP_APP_LINK + path
      this.$apollo
        .mutate({
          mutation: GENERATE_QR,
          variables: {
            link:this.qr_link,
            student_id:this.selected
          }
        })
        .then(response => {
          if (response) {
            this.qr_link = response.data.generateQr.color
            this.QRpopupActive = true
            this.selected = []
            this.headCheckbox = false
            for (let index = 0; index < this.selectedCheck.length; index++) {
              this.selectedCheck[index] = false
            }
          }
        }).catch(error => {
          console.log(error)
        })


    },
    sorting (name) {
      this.namestate = true
      this.state = false
      this.programstate = false
      const column = name
      this.statusorder = true
      const order = this.order
      if (column == 'name' && order == true) {
        this.order = !this.order
        this.students.sort(function (a, b) {
          const textA = a.lname.toUpperCase()
          const textB = b.lname.toUpperCase()
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
        })
      }
      if (column == 'name' && order == false) {
        this.order = !this.order
        this.students.sort(function (a, b) {
          const textA = a.lname.toUpperCase()
          const textB = b.lname.toUpperCase()
          return (textA < textB) ? 1 : (textA > textB) ? -1 : 0
        })
      }
    },
    sortingstatus (name) {
      this.state = true
      this.namestate = false
      this.programstate = false
      const column = name
      this.order = true
      const statusorder = this.statusorder
      if (column == 'status' && statusorder == true) {
        this.statusorder = !this.statusorder
        this.students.sort(function (a, b) {
          const textA = a.status
          const textB = b.status
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
        })
      }
      if (column == 'status' && statusorder == false) {
        this.statusorder = !this.statusorder
        this.students.sort(function (a, b) {
          const textA = a.status
          const textB = b.status
          return (textA < textB) ? 1 : (textA > textB) ? -1 : 0
        })
      }
    },
    sortingprogram (name) {
      this.programstate = true
      this.state = false
      this.namestate = false
      const column = name
      this.order = true
      const programorder = this.programorder
      if (column == 'program' && programorder == true) {
        this.programorder = !this.programorder
        this.students.sort(function (a, b) {
          const textA = a.program.name.toUpperCase()
          const textB = b.program.name.toUpperCase()
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
        })
      }
      if (column == 'program' && programorder == false) {
        this.programorder = !this.programorder
        this.students.sort(function (a, b) {
          const textA = a.program.name.toUpperCase()
          const textB = b.program.name.toUpperCase()
          return (textA < textB) ? 1 : (textA > textB) ? -1 : 0
        })
      }
    },
    getdata (value) {
      if (value) {
        this.get()
      }
    },
    updateCamraList (id) {
      this.custom_search_filter_camera = 'Search By Camera'

      if (id == 'all') {
        this.$apollo
          .mutate({
            mutation: ALL_CAMERAS
          })
          .then(response => {
            this.cameras = response.data.cameras
          })
      } else if (id) {
        this.$apollo
          .mutate({
            mutation: GET_CAMERA_BY_LOCATION,
            variables: {
              location_id:id
            }
          })
          .then(response => {
            if (response) {
              this.cameras = response.data.location_cameras

            }
          }).catch(error => {
            console.log(error)
          })
      }


    },
    PlayCamera (id,code,settings,location) {
      const camera = {id:id,code:code,location:location}
      this.cameraSetting=settings,
      this.cameraCode=camera
      this.activeVideo=true
    },
   closeVideView(){
      this.activeVideo=false
      this.cameraSetting=[]
      this.cameraCode={}
   },
    CheckAll () {
      const selected = []
      if (this.headCheckbox) {
        for (let index = 0; index < this.$refs.table.queriedResults.length; index++) {
          this.selectedCheck[index] = true
          selected.push(this.$refs.table.queriedResults[index].id)
        }
        this.selected = selected
      } else {
        for (let index = 0; index < this.$refs.table.queriedResults.length; index++) {
          this.selectedCheck[index] = false
        }
        this.selected = []
      }
    },
    ConfirmNotification (status) {
      this.$vs.notify({
        title: this.$t('menu.students.name'),
        text: `${status} Successfully!`,
        color: 'success',
        position: 'top-right'
      })
    },
    selectAction (action) {
      this.action = action
      if (action == 'deletestudent') {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Confirm Delete',
          text: `You are about to permanently delete selected ${this.$t('student.titlesmall')}s`,
          accept: this.delefun,
          acceptText: 'Delete'
        })
      } else if (this.selected.length > 0) {
        this.$apollo
          .mutate({
            mutation: USER_EMAIL_CONFIRMED,
            variables: {
              name: action,
              user_ids: this.selected
            }
          }).then(response => {
            if (response) {
              this.ConfirmNotification(response.data.confirmUserEmail.status)
              this.studentMultipleActivity(this.selected,"updated")
              this.selected = []
              this.headCheckbox = false
              for (let index = 0; index < this.selectedCheck.length; index++) {
                this.selectedCheck[index] = false
              }
              this.get()
            }
          }).catch(error => {

          })

      }
    },
    delefun () {
      if (this.selected.length > 0) {
        this.$apollo
          .mutate({
            mutation: USER_EMAIL_CONFIRMED,
            variables: {
              name: this.action,
              user_ids: this.selected
            }
          }).then(response => {
            if (response) {
              this.ConfirmNotification(response.data.confirmUserEmail.status)
              this.studentMultipleActivity(this.selected,"deleted")
              this.selected = []
              this.headCheckbox = false
              for (let index = 0; index < this.selectedCheck.length; index++) {
                this.selectedCheck[index] = false
              }
              this.get()
            }
          }).catch(error => {

          })
      }
    },
    SelectItem (id) {
      if (!this.headCheckbox) {
        let status = false
        for (let i = 0; i < this.selected.length; i++) {
          if (this.selected[i] == id) {
            status = true
          }
        }
        if (status) {
          for (let i = 0; i < this.selected.length; i++) {
            if (this.selected[i] === id) {
              this.selected.splice(i, 1)
            }
          }
        } else {
          this.selected.push(id)
        }
      } else {
        const index = this.selected.indexOf(id)
        if (index > -1) {
          this.selected.splice(index, 1)
        } else {
          this.selected.push(id)
        }
      }
    },
    confStatus (status, id) {
      this.$apollo
        .mutate({
          mutation: UPDATE_STUDENT_STATUS,
          variables: {
            id,
            status
          }
        }).then(response => {
          if (response) {
            console.log(response)
            this.acceptAlert()
            this.studentActivity(id,"updated")
          }
        }).catch(error => {
          console.log(error)
        })

    },

    setSelected (value) {
      this.custom_search_filter = value
    },
    cameraSelected (value) {
      this.custom_search_filter_camera = value
    },
    acceptAlert (status) {
      this.$vs.notify({
        color: 'success',
        title: this.$t('student.alert_title'),
        position:'top-right',
        text: 'Status Updated Successfully!'

      })
    },
    addNewData () {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },
    addSchedule (data) {
      this.scheduleData = data
      this.toggleScheduleSidebar(true)
    },
    addNewCamUser (data) {
      this.camUserSidebarData = data
      this.toggleCamUserSidebar(true)
    },
    settingData (data) {
      this.sidebarSettingData = data

      this.toggleSettingSidebar(true)
    },
    errorMsg () {
      this.$vs.notify({
        title: this.$t('student.alert_title'),
        text:   'Enter Valid Number',
        color:  'danger',
        position: 'top-right'
      })
    },
    StatusSuccess (status, color) {
      this.$vs.notify({
        title: this.$t('student.alert_title'),
        text:   status,
        color,
        position: 'top-right'
      })

    },
    confirmDeleteRecord (student) {
      this.DeletedItem = student
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to permanently delete "${student.fname} ${student.lname}"`,
        accept: this.deleteData,
        acceptText: 'Delete'
      })
    },
    deleteData () {
      this.Imgdlt = this.DeletedItem.image
      this.$apollo
        .mutate({
          mutation: REMOVE_STUDENT,
          variables: {
            id: this.DeletedItem.id
          }
        })
        .then(response => {
          this.get()
          if (response.data.deleteStudent.status == 'Success') {
           
              this.studentActivity(this.DeletedItem.id,"deleted")
              this.selected = []
              this.headCheckbox = false
              for (let index = 0; index < this.selectedCheck.length; index++) {
                this.selectedCheck[index] = false
              }
            this.StatusSuccess(response.data.deleteStudent.message, response.data.deleteStudent.color)
          } else {
            this.StatusSuccess(response.data.deleteStudent.message, response.data.deleteStudent.color)
          }
        }).catch(error => {
          console.log(error)
        })
    //   this.$apollo
    //   .mutate({
    //     mutation: DELETE_IMAGE,
    //     variables: {
    //     image: this.Imgdlt,
    //  },
    //   })
    },
    getCamerasById(location){
      if(location)
       this.$apollo
          .mutate({
            mutation: GET_CAMERA_BY_LOCATION,
            variables: {
              location_id:location
            }
          })
          .then(response => {
            if (response) {
              this.addCameraStudent[location]["new_cameras"]=response.data.location_cameras
              this.addCameraStudent[location]["selected_cameras"]=[]
              

            }
          }).catch(error => {
            console.log(error)
          })
    },
    getLocationName(id){
      for (let index = 0; index < this.locations.length; index++) {
          if(this.locations[index].id==id){

               var locationName =  this.locations[index].name
               break;
          }

        
      }

      // this.getCamerasById(id)
      return locationName

    },
    getSudentForCamera(){
      this.addCameraStudent=[]
      var selected = this.selected
      let filteredStudent = this.students.filter(function (student) {
            return selected.includes(student.id);
      });
       var datas  = filteredStudent.reduce((acc, d) => {
            if (Object.keys(acc).includes(d.location.id)) return acc;

            acc[d.location.id] = filteredStudent.filter(g => g.location.id === d.location.id); 
            return acc;
        }, {})
        // for (let index = 0; index < datas.length; index++) {
        //   const data = datas[index];
        //     data["new_cameras"]=[]
        //     data["selected_cameras"]=[]
        // }

for (const [key, value] of Object.entries(datas)) {
      if(key)
       this.$apollo
          .mutate({
            mutation: GET_CAMERA_BY_LOCATION,
            variables: {
              location_id:key
            }
          })
          .then(response => {
            if (response) {
              this.selectedCameras[key]=[]
              this.newCameras[key]=response.data.location_cameras
               this.$forceUpdate();
            }
          }).catch(error => {
            console.log(error)
          })
          this.$apollo
        .mutate({
          mutation: GET_GROUPS_BY_LOCATION,
          variables: {
            location_id:key
          }
        })
        .then(response => {
          if (response) {
            this.dataGroup = []
            this.newGroups[key]= response.data.location_groups
            this.$forceUpdate();
          }
        }).catch(error => {
          console.log(error)
        })
}
         
         this.addCameraStudent=datas
         this.replaceCameras=false
         this.addCameraPopup=true
    },
      getGroupCamera(group,i){
      if(group.id){
        this.$apollo
        .mutate({
          mutation: GET_GROUP_CAMERAS,
          variables: {
            group_id:group.id
          }
        })
        .then(response => {
          if (response) {
            var cameras= response.data.getGroupCameras;
            for (let index = 0; index < cameras.length; index++) {
              this.selectedCameras[i].push(cameras[index])
            }
             this.$forceUpdate();
             this.selectedCameras[i]=this.selectedCameras[i].filter((v,i,a)=>a.findIndex(t=>(t.id === v.id))===i)
          }
        }).catch(error => {
          console.log(error)
        })
      }
    },
    editData (data) {
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    viewData (data) {
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    toggleScheduleSidebar (val = false) {
      this.addScheduleSidebar = val
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    toggleCamUserSidebar (val = false) {
      this.addNewCamUserSidebar = val
    },
    toggleSettingSidebar (val = false) {
      this.addSettingSidebar = val
    },
    togglePassswordSidebar (val = false) {
      this.addPasswordSidebar = val
    },
    conditionMethod (role, id) {
      if (role == 'manager') {
        this.$apollo
          .mutate({
            mutation: STUDENTS_BY_LOCATION,
            variables: {
              id
            }
          })
          .then(response => {
            this.students = []
            this.locations = response.data.studentsbyLocation.managerlocations
            for (let i = 0; i < response.data.studentsbyLocation.managerlocations.length; i++) {
              for (let j = 0; j < response.data.studentsbyLocation.managerlocations[i].students.length; j++) {
                this.students.push(response.data.studentsbyLocation.managerlocations[i].students[j])
              }
            }
            this.activeLoading = false
            this.$vs.loading.close()
            this.order = !this.order
            this.sorting('name')
          }).catch(error => {
            console.log(error)
          })
        this.$apollo
          .mutate({
            mutation: CAMERAS_BY_MANAGER_LOCATION,
            variables: {
              id
            }
          })
          .then(response => {
            const cameras = []
            const users = []
            for (let i = 0; i < response.data.user.managerlocations.length; i++) {
              for (let j = 0; j < response.data.user.managerlocations[i].cameras.length; j++) {
                cameras.push(response.data.user.managerlocations[i].cameras[j])
              }
            }
            this.cameras = cameras
          }).catch(error => {
            console.log(error)
          })

      }
      if (role == 'user') {
        this.$apollo
          .mutate({
            mutation: SINGLE_USER,
            variables: {
              id
            }
          })
          .then(response => {
            this.students = response.data.user.students
            this.order = !this.order
            this.sorting('name')
            this.activeLoading = false
            this.$vs.loading.close()
          })
      }
      if (role == 'admin' || role == 'center') {
        this.$apollo
          .mutate({
            mutation: ALL_STUDENTS
          })
          .then(response => {
            this.students = response.data.students
            this.order = !this.order
            this.sorting('name')
            this.activeLoading = false
            this.$vs.loading.close()
          })
        this.$apollo
          .mutate({
            mutation: ACTIVE_LOCATIONS
          })
          .then(response => {
            this.locations = response.data.activelocations

          })
        this.$apollo
          .mutate({
            mutation: ALL_CAMERAS
          })
          .then(response => {
            console.log(response)
            this.cameras = response.data.cameras
          })
      }
    },
    get () {
      let userId= localStorage.getItem('userId');
      let userRole = JSON.parse(localStorage.getItem('userRoles'))
      userRole = userRole[0].name
      this.conditionMethod(userRole,userId)
      this.$apollo
        .mutate({
          mutation: ALL_PROGRAMS_QUERY
        })
        .then(response => {
          this.programs = response.data.programs
        })

    },
    loader () {
      this.activeLoading = true
      this.$vs.loading({
        type:'sound'
      })
    },
    studentActivity (id,action) {
      this.$apollo
        .mutate({
          mutation: CREATE_USER_ACTIVITY,
          variables: {
            object_id: id,
            object_type:'App\\Models\\Student',
            activity:action
          }
        })
    },
    studentMultipleActivity (id,action) {
      this.$apollo
        .mutate({
          mutation: CREATE_MULTIPLEUSER_ACTIVITY,
          variables: {
            object_id: id,
            object_type:'App\\Models\\Student',
            activity:action
          }
        })
    },

  },
  created () {
    if (localStorage.getItem('itemsPerPage')) {
      this.itemsPerPage = localStorage.getItem('itemsPerPage')
    }
    this.loader()
    // this.img_cdn = process.env.VUE_APP_IMAGES_CDN_LINK
    this.lng = process.env.VUE_APP_I18N_LOCALE
    this.get()
    // const result = Math.random().toString(36).substring(2, 15)
    this.encrptId = 'getrhmw7zcbabcdefghijklmnTrst1234wxyz07TmnTrst123456Gwxyz07TabcdefghijklmnTrst123456Gwxyz07TabcdefghijklmnTrst123456Gwxyz07TabcdefghijklmnTrst123456Gwxyz07TmnTrst123456Gwxyz07TabcdefghijklmnTrst123456Gwxyz07TabcdefghijklmnTrst123456Gwxyz07TmnTrst123456Gwxyz'


  },
  mounted () {
    this.isMounted = true
  },
  beforeCreate () {
    // this.loader()
    // this.activeLoading = true
    // this.$vs.loading({
    //   type:'sound'
    // })

  }
}
</script>

<style lang="scss">
#data-list-list-view {
.user_add_btn{
    float: right ;
    margin-top: -50px
  }
  .vs-display {
    display: inline-block
  }
  @media (max-width: 461px) {
    .user_add_btn {
      margin-top: 60px
    }
  }
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {

      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
      .product-img {
                height: 50px;
                border-radius: 50%;
              }
  }
  [data-letterstudent]:before {
  content:attr(data-letterstudent);
  }
  .studentdot{
  display:inline-block;
  font-size:35px;
  width:50px;
  height:50px;
  text-align:center;
  border-radius:50%;
  vertical-align:middle;
  margin-right:-10px;
  margin-bottom:5px;
  }
}
 .popupWidth{
    width: 400px !important;
  }
</style>
<style>
ul#menu li {
  display:inline;
}
</style>
<style>
.wizard-progress-with-circle {
  display: none;
}
</style>
